(() => {
  if (window.__baSmsFormBound) return;
  window.__baSmsFormBound = true;

  const SHOP_ID = "962628";
  const SDK_SRC = `https://sdk.postscript.io/sdk.bundle.js?shopId=${SHOP_ID}`;
  const EMBED_SRC = "https://sdk.postscript.io/embeddedForm.bundle.js";

  const digits = (value) => String(value || "").replace(/\D/g, "");

  const formatPhone = (value) => {
    const raw = digits(value).slice(0, 11);
    const n = raw.length === 11 && raw.startsWith("1") ? raw.slice(1) : raw.slice(0, 10);
    if (n.length < 4) return n;
    if (n.length < 7) return `(${n.slice(0, 3)}) ${n.slice(3)}`;
    return `(${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6)}`;
  };

  const toE164 = (value) => {
    let d = digits(value);
    if (d.length === 10) d = `1${d}`;
    if (d.length === 11 && d.startsWith("1")) return `+${d}`;
    return "";
  };

  const applyDiscount = (phone) => {
    try {
      localStorage.setItem("ba-sms-joined", phone || "1");
      sessionStorage.setItem("ba-sms-joined", phone || "1");
    } catch (err) {}
    document.dispatchEvent(new CustomEvent("ba-sms-joined"));
    try {
      window.Shopify?.analytics?.publish?.("ba_sms_joined", {});
    } catch (err) {}
  };

  const showEmbedDone = (existing) => {
    document.querySelectorAll("[data-ba-ps-embed]").forEach((wrap) => {
      if (wrap.querySelector(".ba-sms-done")) return;
      const host = wrap.querySelector("postscript-embedded-form");
      if (host) host.setAttribute("data-ba-done", "");
      const done = document.createElement("div");
      done.className = "ba-sms-done";
      done.setAttribute("role", "status");
      const title = document.createElement("p");
      title.className = "ba-sms-done__title";
      title.textContent = existing ? "You're already in." : "You're in.";
      const copy = document.createElement("p");
      copy.className = "ba-sms-done__copy";
      copy.textContent = existing
        ? "You're on the list. We'll text you first when the Halloween drop goes live."
        : "Check your texts for your 10% code. We'll text you first when the Halloween drop goes live.";
      done.append(title, copy);
      wrap.appendChild(done);
    });
  };

  const POST_VERIFY_STEPS = /email|success/i;
  let verifiedSeen = false;

  const onPostscriptComplete = (event) => {
    const type = event.detail?.type || event.detail?.event || "";
    if (type === "step-change") {
      const into = event.detail?.stepName || "";
      const from = event.detail?.previousStepName || "";
      if (!verifiedSeen && POST_VERIFY_STEPS.test(into) && /verify/i.test(from)) {
        verifiedSeen = true;
        applyDiscount("1");
      }
      return;
    }
    if (type !== "complete" && type !== "subscriberCreated") return;
    const existing = type === "complete" && event.detail?.subscriberStatus === "existing";
    showEmbedDone(existing);
    if (existing) {
      try {
        localStorage.setItem("ba-sms-joined", "existing");
      } catch (err) {}
      document.dispatchEvent(new CustomEvent("ba-sms-known"));
      return;
    }
    applyDiscount(event.detail?.phone || event.detail?.phoneNumber || "1");
  };

  window.addEventListener("postscript:embedded-form", onPostscriptComplete);
  window.addEventListener("postscriptPopup", onPostscriptComplete);

  if (!document.querySelector("script[data-ba-ps-embed]")) {
    const embedScript = document.createElement("script");
    embedScript.src = EMBED_SRC;
    embedScript.async = true;
    embedScript.dataset.baPsEmbed = "1";
    document.head.appendChild(embedScript);
  }

  const EMBED_SKIN = `
    :host { display: block !important; background: transparent !important; width: 100% !important; }
    :host([data-ba-done]) { display: none !important; }
    [class*="overlay-"],
    [class*="mainPopup"],
    .main-popup-scroll-container,
    form,
    div[class*="block-"] {
      background: transparent !important;
      background-color: transparent !important;
      background-image: none !important;
      box-shadow: none !important;
      max-width: 100% !important;
      width: 100% !important;
      min-height: 0 !important;
    }
    form { padding: 0 !important; margin: 0 !important; }
    h2 { display: none !important; }
    input[class*="input-"],
    input[type="tel"],
    input[type="text"] {
      background: transparent !important;
      color: #ede6d9 !important;
      border: 1px solid rgba(237, 230, 217, 0.35) !important;
      border-radius: 0 !important;
      min-height: 5.2rem !important;
      padding: 1.2rem 1.4rem 0.4rem !important;
      font-size: 1.6rem !important;
      letter-spacing: 0.04em !important;
    }
    input.iti__tel-input {
      padding-left: 8.4rem !important;
    }
    .iti__country-container {
      z-index: 3 !important;
    }
    .iti__selected-country,
    .iti__selected-dial-code {
      color: #ede6d9 !important;
      background: transparent !important;
    }
    .iti__arrow {
      border-top-color: #ede6d9 !important;
    }
    .iti__country-list {
      background: #111111 !important;
      color: #ede6d9 !important;
      border: 1px solid rgba(237, 230, 217, 0.2) !important;
    }
    .floating-label,
    span.floating-label {
      background: transparent !important;
      color: #9a9288 !important;
    }
    button[class*="button-"] {
      background: #ede6d9 !important;
      color: #050505 !important;
      border: 0 !important;
      border-radius: 0 !important;
      min-height: 5.2rem !important;
      width: 100% !important;
      letter-spacing: 0.16em !important;
      text-transform: uppercase !important;
      font-weight: 700 !important;
      cursor: pointer !important;
    }
    [class*="small-"] {
      color: #9a9288 !important;
      text-align: left !important;
      line-height: 1.5 !important;
    }
    [class*="link-"] {
      color: #c45c26 !important;
    }
    p, span, div, label {
      color: #ede6d9;
    }
  `;

  const fitItiPadding = (sr) => {
    sr.querySelectorAll(".iti").forEach((wrap) => {
      const input = wrap.querySelector("input.iti__tel-input, input[type='tel']");
      const country = wrap.querySelector(".iti__country-container");
      if (!input || !country) return;
      const width = Math.ceil(country.getBoundingClientRect().width);
      if (width < 40) return;
      input.style.setProperty("padding-left", `${width + 12}px`, "important");
    });
  };

  const skinHost = (host) => {
    const sr = host.shadowRoot;
    if (!sr) return;
    if (!sr.querySelector("style[data-ba-embed-skin]")) {
      const style = document.createElement("style");
      style.dataset.baEmbedSkin = "1";
      style.textContent = EMBED_SKIN;
      sr.appendChild(style);
    }
    sr.querySelectorAll("h2").forEach((heading) => {
      if (/subscribe|10%/i.test(heading.textContent || "")) heading.style.setProperty("display", "none", "important");
    });
    sr.querySelectorAll("button[class*='button-']").forEach((btn) => {
      if (/^subscribe$/i.test((btn.textContent || "").trim())) btn.textContent = "Send code";
    });
    fitItiPadding(sr);
  };

  const skinEmbeds = () => {
    document.querySelectorAll("postscript-embedded-form").forEach(skinHost);
  };

  skinEmbeds();
  const embedWatch = new MutationObserver(skinEmbeds);
  embedWatch.observe(document.documentElement, { childList: true, subtree: true });
  let embedTicks = 0;
  const embedPoll = setInterval(() => {
    skinEmbeds();
    embedTicks += 1;
    if (embedTicks > 40) clearInterval(embedPoll);
  }, 250);

  const ensureSdk = () => {
    if (window.Postscript?.acquisition?.optIn) return Promise.resolve(window.Postscript);
    if (!document.querySelector("script[data-ba-ps-sdk]")) {
      const s = document.createElement("script");
      s.src = SDK_SRC;
      s.async = true;
      s.dataset.baPsSdk = "1";
      document.head.appendChild(s);
    }
    return new Promise((resolve, reject) => {
      const t0 = Date.now();
      const poll = () => {
        if (window.Postscript?.acquisition?.optIn) return resolve(window.Postscript);
        if (Date.now() - t0 > 12000) return reject(new Error("timeout"));
        setTimeout(poll, 40);
      };
      poll();
    });
  };

  ensureSdk().catch(() => {});

  const forms = document.querySelectorAll("[data-ba-sms-form]");
  if (!forms.length) return;

  forms.forEach((form) => {
    const phoneInput = form.querySelector('[name="phone"]');
    const codeInput = form.querySelector('[name="code"]');
    const phoneStep = form.querySelector('[data-step="phone"]');
    const codeStep = form.querySelector('[data-step="code"]');
    const status = form.querySelector("[data-status]");
    const sendBtn = form.querySelector("[data-send]");
    const confirmBtn = form.querySelector("[data-confirm]");
    const backBtn = form.querySelector("[data-back]");
    const resendBtn = form.querySelector("[data-resend]");
    const sourceKey = form.getAttribute("data-source-key") || "ba-onsite";
    const sourceName = form.getAttribute("data-source-name") || "Become Again";
    const opts = { sourceKey, sourceName };
    let pendingPhone = "";

    const setStatus = (msg) => {
      if (status) status.textContent = msg || "";
    };

    const busy = (btn, on) => {
      if (!btn) return;
      btn.disabled = Boolean(on);
    };

    const showCode = () => {
      if (phoneStep) {
        phoneStep.hidden = true;
        phoneStep.classList.remove("is-active");
      }
      if (codeStep) {
        codeStep.hidden = false;
        codeStep.classList.add("is-active");
      }
      setTimeout(() => codeInput?.focus(), 40);
    };

    const showPhone = () => {
      if (codeStep) {
        codeStep.hidden = true;
        codeStep.classList.remove("is-active");
      }
      if (phoneStep) {
        phoneStep.hidden = false;
        phoneStep.classList.add("is-active");
      }
      if (codeInput) codeInput.value = "";
      form.classList.remove("is-done");
      setStatus("");
      phoneInput?.focus();
    };

    const markDone = (msg, isNew = true) => {
      form.classList.add("is-done");
      setStatus(msg);
      if (isNew) applyDiscount(pendingPhone);
    };

    const sendCode = async () => {
      const e164 = toE164(phoneInput?.value);
      if (!e164) {
        setStatus("Enter a real US or CA mobile number.");
        return;
      }
      pendingPhone = e164;
      busy(sendBtn, true);
      busy(resendBtn, true);
      setStatus("Sending…");
      try {
        const ps = await ensureSdk();
        const result = await ps.acquisition.optIn(e164, opts);
        if (result?.subscriberStatus === "subscribed") {
          markDone("You're already on the list.", false);
          return;
        }
        setStatus("");
        showCode();
      } catch (err) {
        setStatus("Couldn't send a code to that number. Check it and try again.");
      } finally {
        busy(sendBtn, false);
        busy(resendBtn, false);
      }
    };

    const confirmCode = async () => {
      const code = digits(codeInput?.value);
      if (code.length < 4) {
        setStatus("Enter the 6-digit code from the text.");
        return;
      }
      busy(confirmBtn, true);
      setStatus("Checking…");
      try {
        const ps = await ensureSdk();
        await ps.acquisition.verify({ phoneNumber: pendingPhone, code }, opts);
        markDone("You're in. Check your texts for your unique 10% code.");
      } catch (err) {
        setStatus("That code didn't match. Try again or resend.");
      } finally {
        busy(confirmBtn, false);
      }
    };

    phoneInput?.addEventListener("input", () => {
      phoneInput.value = formatPhone(phoneInput.value);
    });

    codeInput?.addEventListener("input", () => {
      codeInput.value = digits(codeInput.value).slice(0, 6);
    });

    backBtn?.addEventListener("click", showPhone);
    resendBtn?.addEventListener("click", sendCode);

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const onCode = codeStep && !codeStep.hidden;
      if (onCode) confirmCode();
      else sendCode();
    });
  });
})();
